export const nullifyString = (str: string): string | null =>
  str === "" ? null : str;
